import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c(VCardTitle,[_vm._v(_vm._s(_vm.$t('competitor.checkedIn')))]),_c(VCardText,[_c(VDataTable,{attrs:{"headers":_vm.headers,"items":this.data.checkIns,"hide-default-headers":"","hide-default-footer":"","disable-pagination":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.timestamp",fn:function({item}){return [_vm._v("\n        "+_vm._s(_vm._f("datetime")(item.timestamp))+"\n      ")]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }